// Detección de versión nueva por polling de version.json.
// version.json se genera en cada build (ver vue.config.js) y se sirve sin cache.

const VERSION_FILE = '/version.json';
const DEFAULT_INTERVAL_MS = 3 * 60 * 1000;

let notified = false;

export function getBaselineVersion(): string {
  return process.env.VUE_APP_BUILD_VERSION || '';
}

export async function fetchRemoteVersion(): Promise<string | null> {
  try {
    const res = await fetch(`${VERSION_FILE}?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = await res.json();
    return data && typeof data.version === 'string' ? data.version : null;
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[version-check] no se pudo obtener version.json:', e);
    }
    return null;
  }
}

export async function isNewVersionAvailable(): Promise<boolean> {
  const baseline = getBaselineVersion();
  if (!baseline) return false;
  const remote = await fetchRemoteVersion();
  if (!remote) return false;
  return remote !== baseline;
}

export async function runCheck(onNewVersion: () => void): Promise<void> {
  if (notified) return;
  if (await isNewVersionAvailable()) {
    notified = true;
    onNewVersion();
  }
}

interface VersionCheckRouter {
  afterEach: (cb: () => void) => void;
}

export function startVersionCheck(
  router: VersionCheckRouter,
  onNewVersion: () => void,
  intervalMs: number = DEFAULT_INTERVAL_MS,
): void {
  const check = () => {
    runCheck(onNewVersion).catch(() => {
      // Fallo inesperado en el chequeo; se reintenta en el próximo disparador.
    });
  };

  router.afterEach(check);
  window.addEventListener('focus', check);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
  window.setInterval(check, intervalMs);

  check();
}
